import Vue from "vue";
import Vuex from "vuex";

import qs from "qs";
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        queryData: null,
        readNum: 0,
        activeIndex: "home",
        daibanCount: {
            fapiao: 0,
            gangwei: 0,
            jiesuan: 0,
            kaoqin: 0,
            mianshi: 0,
            richeng: 0,
            ruzhianpai: 0,
            xinjianli: 0
        },
        refresh: false, // websocket 刷新页面数据
        shoujiData: {
            guimo: "",
            rongzi: "",
            shangshi: "",
            hangyelingyuId: "",
            hangyelingyuId2: "",
            hangyelingyu: "",
            hangyelingyu2: "",
            labelId1: "",
            labelId2: "",
            label1: "",
            label2: "",
            xiangmu: "",
            touru: "",
            yuancheng: "",
            daogang: "",
            lianxiren: "",
            mingcheng: "",
            lianxidianhua: "",
            zhiwu: "",
            guanwang: ""
        },
        publishJob: {
            label1: "",
            label2: "",
            label3: "",
            labelId1: "",
            labelId2: "",
            labelId3: "",
            hangyelingyu: "",
            hangyelingyu2: "",
            hangyelingyuId: "",
            hangyelingyuId2: "",
            yuancheng: "1",
            touru: "1",
            yonggong: "1",
            personNum: 1,
            daogang: "1",
            address: "",
            remark: ""
        },
        avatar: "",
        guanjia: '',
        guanjiaName: '',
        guanjiaEWMShow: false,
        creditType: '',
        companyInfo: null,
        mingcheng: '',
        phone: '',
        publishOneJobShow: false,
        isShowGuanbiDia: false,
        loadingShow: false
    },
    mutations: {
        //定义add方法，传入state，即可使用state中的数据
        add(state, obj) {
            state.daibanCount = obj;
        },
        changeTabActive(state, obj) {
            state.activeIndex = obj;
        },
        changeAvatar(state, obj) {
            state.avatar = obj;
        }
    },
    actions: {
        qiyeDaiBanCount(context) {
            // window.fdGlobal.ajax({
            //     method: 'POST',
            //     url: window.fdConfig.url.msgl('qiyeDaiBanCount'),
            //     // URL参数
            //     // 必须是一个纯对象或者 URL参数对象
            //     headers: { 'content-type': 'application/x-www-form-urlencoded' },
            //     data: qs.stringify({}),
            //     //params: '',
            //     // 默认值是json
            //     responseType: 'json'
            // }).then((data) => {
            //     if (data.data.code == 1) {
            //         // context.commit("add",data.data.data)
            //         context.state.daibanCount = data.data.data
            //         //this.daibanCount = data.data.data
            //     }
            // }, (data) => {
            //     this.$message.error(data.data.message);
            // });
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js